/**
 * @fileoverview DELETE handler for the "/alloys/partners/shopify/:app_group_id/bridges/:bridge_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { alloysPartnersShopifyAppGroupIdBridgesBridgeIdCacheKeys } from "./constants";
import type { DeleteAlloysPartnersShopifyAppGroupIdBridgesBridgeIdProps } from "./types";

export const deleteAlloysPartnersShopifyAppGroupIdBridgesBridgeId = reactQueryMutationAdapter(
  alloysPartnersShopifyAppGroupIdBridgesBridgeIdCacheKeys,
  (props: DeleteAlloysPartnersShopifyAppGroupIdBridgesBridgeIdProps): Promise<any> => {
    return fetch(
      `/alloys/partners/shopify/${props.appGroupId}/bridges/${props.bridgeId}`,
      "DELETE",
      props,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
